import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "../shared/header/Header";
import Breadcrumb from "../shared/breadcrumb/Breadcrumb";
import Footer from "../shared/footer/Footer";
import { API_BASE_URL, PAYMENT_STATUS } from "../../config/config";
import AnalyticsService from "../../services/analytics";

export default function PaymentCallback() {
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [orderNumber, setOrderNumber] = useState(null);
  const location = useLocation();
  const timeoutRef = useRef(null);
  const isMounted = useRef(true);

  useEffect(() => {
    AnalyticsService.sendPageView(window.location.pathname);

    const urlParams = new URLSearchParams(location.search);
    const paymentId = urlParams.get("paymentId");
    console.log(paymentId);

    const orderId = sessionStorage.getItem("order_id");
    setOrderNumber(orderId);

    if (orderId) {
      checkOrderStatus(orderId);
    }

    return () => {
      isMounted.current = false;
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  async function checkOrderStatus(orderId) {
    try {
      const response = await fetch(`${API_BASE_URL}/order/status/${btoa(orderId)}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });

      const data = await response.json();

      if (Number(data.transaction_closed) === 0) {
        timeoutRef.current = setTimeout(
          () => checkOrderStatus(orderId),
          5000
        );
      } else {
        setPaymentStatus(data.is_paid);
      }
    } catch (err) {
      if (isMounted.current) {
        console.error("Hiba a rendelés lekérésénél:", err);
      }
    }
  }

  return (
    <div>
      <Header />
      <Breadcrumb />
      <section className="container payment-container">
        <div className="row">
          <div className="col-12">
            <h2 className="h2">Rendelés</h2>
          </div>

          {paymentStatus === null && (
            <div className="col-12">
              <p className="text-center">
                Ellenőrizzük a fizetés sikerességét, kérünk várj…
              </p>
            </div>
          )}

          {/*{paymentStatus !== null && (
            <div className="col-12">
              <p className="text-center">{PAYMENT_STATUS[paymentStatus]}</p>
            </div>
          )}

          {paymentStatus === "Succeeded" && (
            <div className="col-12">
              <p className="text-center">
                Köszönjük a rendelésedet, melyet a{" "}
                <strong>#{orderNumber}</strong> azonosítóval véglegesítettünk.
                <br />
                A visszaigazolást elküldtük az email címedre.
              </p>
              <p className="text-center">
                <Link to="/nyitolap" className="btn btn-primary">
                  tovább a nyitóoldalra
                </Link>
              </p>
            </div>
          )}

          {["Expired", "Canceled", "Failed"].includes(paymentStatus) && (
            <div className="col-12">
              <p className="text-center">
                A fizetés sikertelen volt! Kérjük, próbáld meg újra vagy válassz másik
                fizetési módot.
              </p>
              <p className="text-center">
                <Link to="/penztar" className="btn btn-primary">
                  tovább a pénztárhoz
                </Link>
              </p>
            </div>
          )}*/}

          {Number(paymentStatus) === 1 && (
            <div className="col-12">
              <p className="text-center">
                Köszönjük a rendelésedet, melyet a{" "}
                <strong>#{orderNumber}</strong> azonosítóval véglegesítettünk.
                <br />
                A visszaigazolást elküldtük az email címedre.
              </p>
              <p className="text-center">
                <Link to="/nyitolap" className="btn btn-primary" style={{maxWidth: "250px"}}>
                  tovább a nyitóoldalra
                </Link>
              </p>
            </div>
          )}

          {paymentStatus !== null && Number(paymentStatus) === 0 && (
            <div className="col-12">
              <p className="text-center">
                A fizetés sikertelen volt! Kérjük, próbáld meg újra vagy válassz másik
                fizetési módot. Az elutasítás okáról e-mailben tájékoztatunk.
              </p>
              <p className="text-center">
                <Link to="/penztar" className="btn btn-primary" style={{maxWidth: "250px"}}>
                  tovább a pénztárhoz
                </Link>
              </p>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}
